import React from 'react';

const NoResult = () => <div className="c-search__no-result">No result found.</div>;

export default NoResult;
